import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Resolve an absolute API URL that works in development (vite or vercel dev)
 * and production environments (including custom domains).
 */
export function resolveApiUrl(path: string) {
  const sanitizedPath = path.startsWith('/') ? path : `/${path}`;

  const vercelUrl = import.meta.env.VITE_VERCEL_API_URL?.replace(/\/$/, '');
  if (vercelUrl) {
    const [base] = vercelUrl.split('/api');
    if (base) {
      return `${base}${sanitizedPath}`;
    }
    return `${vercelUrl}${sanitizedPath}`;
  }

  const configuredBase = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '');
  if (configuredBase) {
    return `${configuredBase}${sanitizedPath}`;
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${sanitizedPath}`;
  }

  return sanitizedPath;
}
